// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post } from "@insite/client-framework/Services/ApiService";

// XNG-Changes
const createAccountUrl = "/api/pls/register";

export const enum createAccountConstants {
    firstAndLastName = "Your First & Last Name",
    email = "Email",
    phone = "Phone",
    accountName = "Your current Account name",
    accountNumber = "Your current account number (if known)",
    address = "Address",
    branch = "Which branch do you normally do business with?",
    accountNewOrExisting = "Plumbers' Supply Account?",
}

export interface CreateAccountFields {
    [createAccountConstants.firstAndLastName]: string;
    [createAccountConstants.email]: string;
    [createAccountConstants.phone]?: string;
    [createAccountConstants.accountName]?: string;
    [createAccountConstants.accountNumber]?: string;
    [createAccountConstants.address]?: string;
    [createAccountConstants.branch]?: string;
    [createAccountConstants.accountNewOrExisting]?: string;
}

export function postCreateAccount(parameter: CreateAccountFields) {
    const params = {
        fields: {
            ...parameter,
        },
    };
    return post(`${createAccountUrl}/`, params);
}
